var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 19.334L16.0002 22.0007L18.6668 19.334",
    stroke: "#001A37",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V22",
    stroke: "#001A37",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.92 20.06C22.4996 19.6524 22.9342 19.0707 23.1608 18.3994C23.3874 17.7281 23.3942 17.002 23.1802 16.3265C22.9662 15.651 22.5425 15.0613 21.9707 14.643C21.3988 14.2246 20.7085 13.9994 20 14H19.16C18.9594 13.2185 18.5843 12.4928 18.0627 11.8773C17.5411 11.2619 16.8867 10.7728 16.1488 10.4469C15.4108 10.1209 14.6085 9.96664 13.8023 9.99563C12.9961 10.0246 12.207 10.2361 11.4943 10.6142C10.7817 10.9923 10.1641 11.5272 9.68808 12.1785C9.21206 12.8298 8.88999 13.5807 8.74613 14.3745C8.60227 15.1683 8.64036 15.9844 8.85754 16.7613C9.07472 17.5383 9.46533 18.2558 9.99996 18.86",
    stroke: "#001A37",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceAction);
export default __webpack_public_path__ + "static/media/invoice-action.a345d17dfca15542ba91803152a6cf9f.svg";
export { ForwardRef as ReactComponent };